import { useState } from 'react';

declare global {
  interface Window {
    electron?: {
      clipboard: {
        writeText: (text: string) => void;
      };
    };
  }
}

type CopiedValue = string | null;

type CopyFn = (text: string) => Promise<boolean>;

type ReturnType = {
  copy: CopyFn;
  copiedText: CopiedValue;
};

function useCopyToClipboard(): ReturnType {
  const [copiedText, setCopiedText] = useState<CopiedValue>(null);

  const copy: CopyFn = async (text) => {
    let copiedSuccessfully = false;

    try {
      if (navigator?.clipboard) {
        await navigator.clipboard.writeText(text);
        copiedSuccessfully = true;
      }
    } catch (error) {
      console.warn('Failed to copy to browser clipboard:', error);
    }

    try {
      if (window?.electron?.clipboard) {
        window.electron.clipboard.writeText(text);
        copiedSuccessfully = true;
      }
    } catch (error) {
      console.warn('Failed to copy to Electron clipboard:', error);
    }

    if (copiedSuccessfully) {
      setCopiedText(text);
    } else {
      setCopiedText(null);
    }

    return copiedSuccessfully;
  };

  return { copiedText, copy };
}
export default useCopyToClipboard;
